export const chambresRdc = [
      /*{
            id: 1,
            img: "/pictures/descriptif/chambrerdc/rdc_chambre3.jpg",
            alt: "Chambre 1 rez de chausse",
            class: "photo_court_format",
            index: 0,
      },

      {
            id: 2,
            img: "/pictures/descriptif/chambrerdc/rdc_chambre4.jpg",
            alt: "Chambre 2 rez de chausse",
            class: "photo_court_format",
            index: 1,
      },

      {
            id: 3,
            img: "/pictures/descriptif/chambrerdc/rdc_chambre7.jpg",
            alt: "Chambre 3 rez de chausse",
            class: "photo_court_format",
            index: 2,
      },*/

      {
            id: 3,
            img: "/pictures/descriptif/chambrerdc/rdc_chambre_3.jpg",
            alt: "Chambre 3 rez de chausse",
            class: "photo_court_format",
            index: 2,
      },

      {
            id: 2,
            img: "/pictures/descriptif/chambrerdc/rdc_chambre_2.jpg",
            alt: "Chambre 2 rez de chausse",
            class: "photo_court_format",
            index: 1,
      },

      {
            id: 1,
            img: "/pictures/descriptif/chambrerdc/rdc_chambre_1.jpg",
            alt: "Chambre 1 rez de chausse",
            class: "photo_court_format",
            index: 0,
      },

      
];

export const cuisines = [
      {
            id: 1,
            img: "/pictures/descriptif/cuisine/rdc_cuisine1.jpg",
            alt: "Cuisine 1 rez de chausse",
            class: "photo_long_format",
            index: 3,
      },

      {
            id: 2,
            img: "/pictures/descriptif/cuisine/rdc_cuisine3.jpg",
            alt: "Cuisine 3 rez de chausse",
            class: "photo_long_format",
            index: 4,
      },

      {
            id: 3,
            img: "/pictures/descriptif/cuisine/rdc_cuisine6.jpg",
            alt: "Cuisine 2 rez de chausse",
            class: "photo_court_format",
            index: 5,
      },
];

export const cuisinesDetails = [
      {
            id: 1,
            img: "/pictures/details/cuisine/rdc_cuisine9.jpg",
            alt: "Cuisine 1 rez de chausse",
            class: "",
            index: 6,
      },

      {
            id: 2,
            img: "/pictures/details/cuisine/rdc_cuisine10.jpg",
            alt: "Cuisine 2 rez de chausse",
            class: "",
            index: 7,
      },

      {
            id: 3,
            img: "/pictures/details/cuisine/rdc_cuisine12.jpg",
            alt: "Cuisine 3 rez de chausse",
            class: "",
            index: 8,
      },

      {
            id: 4,
            img: "/pictures/details/cuisine/rdc_frigo.jpg",
            alt: "Cuisine 4 rez de chausse",
            class: "",
            index: 9,
      },

      {
            id: 5,
            img: "/pictures/buanderie/rdc_machine_a_laver.jpg",
            alt: "Machine à laver",
            class: "photo_long_format",
            index: 10,
      },
];

export const salons = [

      {
            id: 2,
            img: "/pictures/descriptif/salon/rdc_chaumiere5.jpg",
            alt: "",
            index: 12,
      },

      {
            id: 1,
            img: "/pictures/descriptif/salon/rdc_chaumiere4.jpg",
            alt: "Salon 1 rez de chausse",
            class: "",
            index: 13,
      },

      {
            id: 3,
            img: "/pictures/descriptif/salon/rdc_salon1.jpg",
            alt: "Salon 3 rez de chausse",
            class: "photo_long_format",
            index: 11,
      },
];

export const salonsDetails = [
      {
            id: 1,
            img: "/pictures/details/salon/rdc_tele.jpg",
            alt: "Salon details rez de chausse",
            class: "",
            index: 14,
      },
];

export const sallesAManger = [
      {
            id: 1,
            img: "/pictures/descriptif/sallemanger/rdc_salon2.jpg",
            alt: "Salle à manger du gite le cormier",
            class: "",
            index: 15,
      },

      {
            id: 2,
            img: "/pictures/descriptif/sallemanger/rdc_salon3.jpg",
            alt: "Salle à manger du gite le cormier",
            class: "",
            index: 16,
      },

      {
            id: 3,
            img: "/pictures/descriptif/sallemanger/rdc_salon4.jpg",
            alt: "Salle à manger du gite le cormier",
            class: "",
            index: 17,
      },
];

export const sallesAMangerDetails = [
      {
            id: 1,
            img: "/pictures/details/sallemanger/rdc_biblio1.jpg",
            alt: "Salle à manger du gite le cormier",
            class: "",
            index: 18,
      },

      {
            id: 2,
            img: "/pictures/details/sallemanger/rdc_biblio2.jpg",
            alt: "Salle à manger du gite le cormier",
            class: "",
            index: 19,
      },
];

export const sallesDeBain = [
      {
            id: 2,
            img: "/pictures/descriptif/sdb/rdc_douche3.jpg",
            alt: "Salle de bain du gite le cormier",
            class: "",
            index: 20,
      },

      {
            id: 1,
            img: "/pictures/descriptif/sdb/rdc_douche1.jpg",
            alt: "Salle de bain du gite le cormier",
            class: "photo_long_format",
            index: 21,
      },
];

export const chambre1Etages = [
      {
            id: 1,
            img: "/pictures/descriptif/chambre1/etage6.jpg",
            alt: "Chambre 1 du 1er étage du gite le cormier",
            class: "",
            index: 22,
      },

      {
            id: 2,
            img: "/pictures/descriptif/chambre1/etage7.jpg",
            alt: "Chambre 1 du 1er étage du gite le cormier",
            class: "",
            index: 23,
      },

      {
            id: 3,
            img: "/pictures/descriptif/chambre1/etage8.jpg",
            alt: "Chambre 1 du 1er étage du gite le cormier",
            class: "",
            index: 24,
      },
];

export const chambre1EtagesDetails = [
      {
            id: 2,
            img: "/pictures/details/chambre1/image008.jpg",
            alt: "Détails de la Chambre 1 du 1er étage du gite le cormier",
            class: "",
            index: 25,
      },

      {
            id: 3,
            img: "/pictures/details/chambre1/image010.jpg",
            alt: "Détails de la Chambre 1 du 1er étage du gite le cormier",
            class: "",
            index: 26,
      },

      {
            id: 1,
            img: "/pictures/details/chambre1/etage14.jpg",
            alt: "Détails de la Chambre 1 du 1er étage du gite le cormier",
            class: "",
            index: 27,
      },
];

export const chambre2Etages = [

      

      {
            id: 3,
            img: "/pictures/descriptif/chambre2/chambre_2_lit_etage_3.jpg",
            alt: "",
            index: 30,
      },

      {
            id: 1,
            img: "/pictures/descriptif/chambre2/chambre_2_lit_etage_1.jpg",
            alt: "Chambre 2 du 1er étage du gite le cormier",
            //class: "photo_long_format",
            index: 28,
      },

      {
            id: 2,
            img: "/pictures/descriptif/chambre2/chambre_2_lit_etage_2.jpg",
            alt: "Chambre 2 du 1er étage du gite le cormier",
            class: "",
            index: 29,
      },

      
];

export const chambre2EtagesDetails = [
      {
            id: 1,
            img: "/pictures/details/chambre2/etage5.jpg",
            alt: "Détails de la Chambre 2 du 1er étage du gite le cormier",
            class: "",
            index: 31,
      },
      {
            id: 1,
            img: "/pictures/details/chambre2/chambre_2_detail.jpg",
            alt: "Détails de la Chambre 2 du 1er étage du gite le cormier",
            class: "",
            index: 31,
      },
];


export const jardins = [
      {
            id: 15,
            img: "/pictures/jardin/RMV_5558.jpg",
            alt: "Le jardin du gite le cormier",
            index: 39,
      },

      {
            id: 18,
            img: "/pictures/jardin/RMV_5561.jpg",
            alt: "Le jardin du gite le cormier",
            index: 42,
      },

      {
            id: 21,
            img: "/pictures/jardin/RMV_5633.jpg",
            alt: "Le jardin du gite le cormier",
            index: 44,
      },

      {
            id: 24,
            img: "/pictures/jardin/RMV_5652.jpg",
            alt: "Le jardin du gite le cormier",
            index: 48,
      },

       {
            id: 13,
            img: "/pictures/jardin/RMV_5555.jpg",
            alt: "Le jardin du gite le cormier",
            index: 35,
      },

      {
            id: 14,
            img: "/pictures/jardin/RMV_5557.jpg",
            alt: "Le jardin du gite le cormier",
            index: 38,
      },

      {
            id: 1,
            img: "/pictures/jardin/image009.jpg",
            alt: "Le jardin du gite le cormier",
            index: 32,
      },

      {
            id: 3,
            img: "/pictures/jardin/image114.jpg",
            alt: "Le jardin du gite le cormier",
            index: 33,
      },

      /*{
            id: 11,
            img: "/pictures/jardin/RMV_5551.jpg",
            alt: "Le jardin du gite le cormier",
            class: "",
            index: 34,
      },*/

      {
            id: 2,
            img: "/pictures/jardin/image106.jpg",
            alt: "Le jardin du gite le cormier",
            index: 37,
      },

      {
            id: 4,
            img: "/pictures/jardin/image119.jpg",
            alt: "Le jardin du gite le cormier",
            index: 36,
      },

      {
            id: 5,
            img: "/pictures/jardin/image124.jpg",
            alt: "Le jardin du gite le cormier",
            index: 40,
      },

      {
            id: 6,
            img: "/pictures/jardin/image129.jpg",
            alt: "Le jardin du gite le cormier",
            index: 41,
      },

      /*{
            id: 20,
            img: "/pictures/jardin/RMV_5563.jpg",
            alt: "Le jardin du gite le cormier",
            index: 43,
      },*/


      /*{
            id: 23,
            img: "/pictures/jardin/RMV_5649.jpg",
            alt: "Le jardin du gite le cormier",
            index: 45,
      },*/

      {
            id: 7,
            img: "/pictures/jardin/IMG20230603175357.jpg",
            alt: "Le jardin du gite le cormier",
            index: 46,
      },

      {
            id: 8,
            img: "/pictures/jardin/IMG20230603175559.jpg",
            alt: "Le jardin du gite le cormier",
            index: 47,
      },

      /*{
            id: 19,
            img: "/pictures/jardin/RMV_5562.jpg",
            alt: "Le jardin du gite le cormier",
            class: "photo_long_format",
            index: 49,
      },*/

      {
            id: 10,
            img: "/pictures/jardin/IMG20230603180059.jpg",
            alt: "Le jardin du gite le cormier",
            class: "photo_long_format",
            index: 50,
      },

      /*{
            id: 25,
            img: "/pictures/jardin/RMV_5653.jpg",
            alt: "Le jardin du gite le cormier",
            class: "photo_long_format",
            index: 51,
      },*/
      
      {
            id: 9,
            img: "/pictures/jardin/IMG20230603175726.jpg",
            alt: "Le jardin du gite le cormier",
            index: 52,
      },

      /*{
            id: 30,
            img: "/pictures/jardin/jardin_neige.jpeg",
            alt: "Le jardin du gite le cormier",
            index: 52,
      },*/

      {
            id: 30,
            img: "/pictures/jardin/img_gite_neige_1.jpg",
            alt: "Le jardin du gite le cormier",
            index: 52,
      },

      {
            id: 31,
            img: "/pictures/jardin/img_gite_neige_2.jpg",
            alt: "Le jardin du gite le cormier",
            index: 52,
      },

      {
            id: 32,
            img: "/pictures/jardin/neige.jpg",
            alt: "Le jardin du gite le cormier",
            index: 52,
      },

      {
            id: 33,
            img: "/pictures/jardin/img_gite_neige_4.jpg",
            alt: "Le jardin du gite le cormier",
            index: 52,
      },

      {
            id: 34,
            img: "/pictures/jardin/img_gite_neige_5.jpg",
            alt: "Le jardin du gite le cormier",
            index: 52,
      },

      /*{
            id: 36,
            img: "/pictures/jardin/img_gite_neige_7.jpg",
            alt: "Le jardin du gite le cormier",
            index: 52,
      },*/

      {
            id: 37,
            img: "/pictures/jardin/lumiere.jpg",
            alt: "Le jardin du gite le cormier",
            index: 52,
      },

      {
            id: 35,
            img: "/pictures/jardin/img_gite_neige_6.jpg",
            alt: "Le jardin du gite le cormier",
            index: 52,
      }
      
];

export const jardinsDetails = [
      {
            id: 1,
            img: "/pictures/details/jardin/barbeuk001.jpg",
            alt: "Le jardin du gite le cormier",
            index: 53,
      },

      {
            id: 2,
            img: "/pictures/details/jardin/champi001.jpg",
            alt: "Le jardin du gite le cormier",
            index: 54,
      },

      {
            id: 3,
            img: "/pictures/details/jardin/image013.jpg",
            alt: "Le jardin du gite le cormier",
            index: 55,
      },

      {
            id: 8,
            img: "/pictures/details/jardin/IMG20230603175641.jpg",
            alt: "Le jardin du gite le cormier",
            index: 56,
      },

      {
            id: 9,
            img: "/pictures/details/jardin/IMG20230603175841.jpg",
            alt: "Le jardin du gite le cormier",
            index: 57,
      },

      {
            id: 12,
            img: "/pictures/jardin/img_fleur.jpg",
            alt: "Le jardin du gite le cormier",
            class: "",
            index: 63,
      },

      {
            id: 4,
            img: "/pictures/details/jardin/image101.jpg",
            alt: "Le jardin du gite le cormier",
            index: 58,
      },

      {
            id: 6,
            img: "/pictures/details/jardin/IMG20230603175320.jpg",
            alt: "Le jardin du gite le cormier",
            index: 59,
      },

      {
            id: 7,
            img: "/pictures/details/jardin/IMG20230603175529.jpg",
            alt: "Le jardin du gite le cormier",
            index: 60,
      },

      {
            id: 5,
            img: "/pictures/details/jardin/IMG-20230611-WA0007.jpeg",
            alt: "Le jardin du gite le cormier",
            index: 61,
      },

      {
            id: 10,
            img: "/pictures/jardin/RMV_5560.jpg",
            alt: "Le jardin du gite le cormier",
            index: 62,
      },

      {
            id: 11,
            img: "/pictures/jardin/RMV_5554.jpg",
            alt: "Le jardin du gite le cormier",
            class: "",
            index: 63,
      },

];